import React, { useEffect, useState } from 'react';

import { Container, Button, Alert } from 'react-bootstrap';

import InputClient from '../../components/Mod/InputClient/InputClient';
import FormSelect from '../../components/Mod/FormSelect/FormSelect';
import FormClientContact from '../../components/Mod/FormClientContact/FormClientContact';

import './CreateAssessmentPage.css';
import { createAssessment } from '../../api/services/CreateAssessment';

const AssessmentList = () => [
  {
    name: 'Registration',
    type: 'assessment',
    code: 'registration',
  },
  {
    name: 'Nutrition Screening',
    type: 'assessment',
    code: 'nutriscreen',
  },
  {
    name: 'Constent to Treat',
    type: 'document',
    code: 'txconsent',
  },
  {
    name: 'No Show Policy',
    type: 'document',
    code: 'noshow',
  },
];

const CreateAssessmentPage = () => {
  const [client, setClient] = useState({
    clientId: '',
    email: '',
    phone: '',
    firstName: '',
    lastName: '',
    birthDate: '',
    contactPreference: '',
    valid: false,
  });

  const [showSuccess, setShowSuccess] = useState(false);
  const [formDisabled, setFormDisabled] = useState(true);
  const [bundleKey, setBundleKey] = useState('');

  const [assessments, setAssessments] = useState([]);

  const resetNewClient = () => {
    setShowSuccess(false);

    const assessmentList = AssessmentList().map((prev) => ({
      ...prev,
      isChecked: false,
      isDisabled: false,
    }));
    setAssessments(assessmentList);

    setClient((prev) => ({
      ...prev,
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      birthDate: '',
      contactPreference: '',
      valid: false,
    }));
  };

  const resetPage = () => {
    const assessmentList = AssessmentList().map((prev) => ({
      ...prev,
      isChecked: false,
      isDisabled: false,
    }));
    setAssessments(assessmentList);

    setClient({
      clientId: '',
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      birthDate: '',
      contactPreference: '',
      valid: false,
    });

    setFormDisabled(true);
  };

  useEffect(() => {
    resetPage();
  }, []);

  const handleClick = () => {
    const assignedAssessments = assessments
      .filter((assessment) => (assessment.isChecked === true))
      .map(({ code }) => code);
    const data = {
      clientId: client.clientId,
      assessments: assignedAssessments,
    };

    createAssessment(data)
      .then((res) => {
        setBundleKey(res.data.assessment_bundle.bundleKey);
        console.log(res.data);
        resetPage();
        setShowSuccess(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <Container>
        <Alert
          variant="success"
          show={showSuccess}
          onClose={() => setShowSuccess(false)}
          dismissible
        >
          Assessment Sent -
          {' '}
          {bundleKey}

        </Alert>
        <InputClient
          client={client}
          setClient={setClient}
          resetPage={resetNewClient}
          setFormDisabled={setFormDisabled}
        />
        <FormSelect
          section="Assessments"
          type="assessment"
          assessments={assessments}
          setAssessments={setAssessments}
          formDisabled={formDisabled}
        />
        <FormSelect
          section="Documents"
          type="document"
          assessments={assessments}
          setAssessments={setAssessments}
          formDisabled={formDisabled}
        />
        <FormClientContact
          client={client}
          setClient={setClient}
          formDisabled={formDisabled}
        />
        <br />
        <Button onClick={handleClick} disabled={formDisabled}>Send Assessments</Button>
      </Container>
    </div>
  );
};

export default CreateAssessmentPage;
